import http from './_http'

const WSFinder = (m) => { return http.post(`/wsfinder`, m); }
const WSFinder_Call = (a, b, c) => WSFinder({target: a, cmd : b, body: c});
const WSFinderLatest = (branch='release') => { return http.get(`/${branch}/latest/wsfinder`); }

const wsfinder = { WSFinder, WSFinder_Call, WSFinderLatest}


export default wsfinder
export { WSFinder, WSFinder_Call, WSFinderLatest }
